"use strict";Object.defineProperty(exports, "__esModule", {value: true});var DirectoryTab; (function (DirectoryTab) {
  const PATIENTS = "PATIENTS"; DirectoryTab["PATIENTS"] = PATIENTS;
  const COWORKERS = "COWORKERS"; DirectoryTab["COWORKERS"] = COWORKERS;
  const TEAMS = "TEAMS"; DirectoryTab["TEAMS"] = TEAMS;
})(DirectoryTab || (exports.DirectoryTab = DirectoryTab = {}));
